import * as Sentry from '@sentry/react'
import { instrumentClientFetch, sanitizeLogContext } from './utils/observability'

const dsn = import.meta.env.VITE_SENTRY_DSN
const environment = import.meta.env.MODE
// Injected at build time to match the release used when uploading source maps.
const release = typeof __SENTRY_RELEASE__ !== 'undefined' ? __SENTRY_RELEASE__ : undefined

if (dsn) {
  Sentry.init({
    dsn,
    environment,
    release,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({
        levels: ['warn', 'error'],
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
    beforeSendLog: (log) => ({
      ...log,
      attributes: sanitizeLogContext(
        (log as { attributes?: Record<string, unknown> }).attributes
      ),
    }),
  })
}

instrumentClientFetch()
